import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const fetchOfferDetails = async (offerId) => {
  const response = await axiosInstance.get(`/offers/${offerId}/`);
  return response.data;
};

export const useGetOfferDetails = (offerId, options = {}) => {
  const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['mpOffer', offerId],
    queryFn: () => fetchOfferDetails(offerId),
    enabled: (options.enabled ?? true) && offerId != null,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  return {
    offer: data,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
